export default __webpack_public_path__ + "static/cni_logo-40d4903135c27e62e0c958430e65fd39.png";